import React from 'react';
import { Link } from 'react-router-dom';
import { LinkedinLogo, TwitterLogo, EnvelopeSimple, MapPin } from '@phosphor-icons/react';
import VentriqoLogo from '../components/VentriqoLogo';

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div>
            <VentriqoLogo className="h-8 w-auto mb-4" dark />
            <p className="text-sm text-gray-400 leading-relaxed">
              Daily AI-bookkeeping + Fractional CFO. Finance-as-a-Service for ambitious businesses.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-gray-400 mb-4">Services</h4>
            <ul className="space-y-2">
              <li><Link to="/services" className="text-sm text-gray-300 hover:text-white transition-colors">Bookkeeping</Link></li>
              <li><Link to="/services#compliance" className="text-sm text-gray-300 hover:text-white transition-colors">Compliance</Link></li>
              <li><Link to="/services#cfo" className="text-sm text-gray-300 hover:text-white transition-colors">FP&A / CFO</Link></li>
              <li><Link to="/pricing" className="text-sm text-gray-300 hover:text-white transition-colors">Pricing</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-gray-400 mb-4">Company</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-gray-300 hover:text-white transition-colors">About</Link></li>
              <li><Link to="/blog" className="text-sm text-gray-300 hover:text-white transition-colors">Blog</Link></li>
              <li><Link to="/contact" className="text-sm text-gray-300 hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-gray-400 mb-4">Connect</h4>
            <div className="flex gap-4 mb-4">
              <a href="https://linkedin.com/company/ventriqo" target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin" className="text-gray-400 hover:text-white transition-colors">
                <LinkedinLogo size={20} />
              </a>
              <a href="https://x.com/Ankit_classic" target="_blank" rel="noopener noreferrer" data-testid="footer-twitter" className="text-gray-400 hover:text-white transition-colors">
                <TwitterLogo size={20} />
              </a>
              <a href="mailto:support@ventriqo.com" data-testid="footer-email" className="text-gray-400 hover:text-white transition-colors">
                <EnvelopeSimple size={20} />
              </a>
            </div>
            <p className="text-sm text-gray-400">support@ventriqo.com</p>
            <p className="text-sm text-gray-400 mb-4">sales@ventriqo.com</p>
            <div className="space-y-2">
              <div className="flex items-start gap-2">
                <MapPin size={14} className="text-gray-500 flex-shrink-0 mt-0.5" />
                <p className="text-xs text-gray-500">Kudlu Gate, Electronic City, Bangalore, India</p>
              </div>
              <div className="flex items-start gap-2">
                <MapPin size={14} className="text-gray-500 flex-shrink-0 mt-0.5" />
                <p className="text-xs text-gray-500">Salman Commercial Tower, Business Bay, Dubai, UAE</p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-gray-500">&copy; {new Date().getFullYear()} Ventriqo. All rights reserved.</p>
          <div className="flex gap-6">
            <a href="#" className="text-xs text-gray-500 hover:text-gray-300 transition-colors">Privacy Policy</a>
            <a href="#" className="text-xs text-gray-500 hover:text-gray-300 transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
